import React from "react"
import { Link } from "gatsby"

const Logo = () => (
  <h1>
    <Link href="/" style={{ "text-decoration": "none" }}>
      <span style={{ color: "#73abff" }}>Modern</span>
      <span style={{ color: "#d89bfe" }}>Dev</span>
      <span style={{ color: "#f79f7f" }}>.</span>
      <span style={{ color: "#149F9F" }}>Tech</span>
    </Link>
  </h1>
)

export default Logo
